import SettingRoute from './SettingRoute';

export default SettingRoute;
